/**
 * Helper function to lighten or darken entered HEX color
 * @param colorHEX - HEX value of color
 * @param amount - amount of lighten or darken (base10 integer value: negative value darken, positive value lighten)
 * @returns - new lighten or darken color in HEX
 */
export function lightenDarkenColor(colorHEX: string, amount: number) {
  let usePound = false
  if (colorHEX[0] == '#') {
    colorHEX = colorHEX.slice(1)
    usePound = true
  }

  const num = parseInt(colorHEX, 16)

  let r = (num >> 16) + amount

  if (r > 255) r = 255
  else if (r < 0) r = 0

  let b = ((num >> 8) & 0x00ff) + amount

  if (b > 255) b = 255
  else if (b < 0) b = 0

  let g = (num & 0x0000ff) + amount

  if (g > 255) g = 255
  else if (g < 0) g = 0

  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16)
}
